module.exports = __webpack_public_path__ + "img/conny-stage7-blink.46fdac48.png";